import { ReduxStateHandler } from '../ReduxStateHandler';

export const DROPOFF_SURVEY_TYPEFORM_ID = 'r6DYZDmf';

export const TypeformModalStateHandler = new ReduxStateHandler({
  actionName: 'data/UPDATE_TYPEFORM_MODAL',
  statePath: 'typeformModalData',
});
